import React, { memo } from "react";
import Image from "next/image";
import { resolvedPublicPath } from "utils/utils";

function Footer() {
	return (
		<div className="flex pt-16 items-center justify-center">
			<a href="https://yocale.com" title="Yocale.com">
				<Image
					src={resolvedPublicPath("yocale-logo.svg")}
					alt={"Powered by Yocale"}
					width={77}
					height={33}
					loading="lazy"
				/>
			</a>
		</div>
	);
}

export default memo(Footer);
